// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SnowHuntRouteImport } from './routes/snow-hunt'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SnowHuntStatusRouteImport } from './routes/snow-hunt_.status'
import { Route as SearchStatusRouteImport } from './routes/search_.status'
import { Route as SettingsQuotasRouteImport } from './routes/settings.quotas'
import { Route as SettingsPoliciesRouteImport } from './routes/settings.policies'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsLocationsRouteImport } from './routes/settings.locations'
import { Route as SettingsDispatcherRouteImport } from './routes/settings.dispatcher'
import { Route as SettingsCacheRouteImport } from './routes/settings.cache'
import { Route as SettingsAuditLogsRouteImport } from './routes/settings.audit-logs'
import { Route as SettingsAnalyticsRouteImport } from './routes/settings.analytics'
import { Route as SettingsAdvancedRouteImport } from './routes/settings.advanced'
import { Route as ProfileAccountIdRouteImport } from './routes/profile.$accountId'
import { Route as SettingsAuditLogsLogIdRouteImport } from './routes/settings.audit-logs.$logId'

const SnowHuntRoute = SnowHuntRouteImport.update({
            id: '/snow-hunt',path: '/snow-hunt',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const CallbackRoute = CallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SnowHuntStatusRoute = SnowHuntStatusRouteImport.update({
            id: '/snow-hunt_/status',path: '/snow-hunt/status',getParentRoute: () => rootRouteImport
          })
const SearchStatusRoute = SearchStatusRouteImport.update({
            id: '/search_/status',path: '/search/status',getParentRoute: () => rootRouteImport
          })
const SettingsQuotasRoute = SettingsQuotasRouteImport.update({
            id: '/quotas',path: '/quotas',getParentRoute: () => SettingsRoute
          })
const SettingsPoliciesRoute = SettingsPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => SettingsRoute
          })
const SettingsDispatcherRoute = SettingsDispatcherRouteImport.update({
            id: '/dispatcher',path: '/dispatcher',getParentRoute: () => SettingsRoute
          })
const SettingsCacheRoute = SettingsCacheRouteImport.update({
            id: '/cache',path: '/cache',getParentRoute: () => SettingsRoute
          })
const SettingsAuditLogsRoute = SettingsAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => SettingsRoute
          })
const SettingsAnalyticsRoute = SettingsAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => SettingsRoute
          })
const SettingsAdvancedRoute = SettingsAdvancedRouteImport.update({
            id: '/advanced',path: '/advanced',getParentRoute: () => SettingsRoute
          })
const ProfileAccountIdRoute = ProfileAccountIdRouteImport.update({
            id: '/$accountId',path: '/$accountId',getParentRoute: () => ProfileRoute
          })
const SettingsAuditLogsLogIdRoute = SettingsAuditLogsLogIdRouteImport.update({
            id: '/$logId',path: '/$logId',getParentRoute: () => SettingsAuditLogsRoute
          })





const ProfileRouteChildren = {
  ProfileAccountIdRoute: ProfileAccountIdRoute
}

const ProfileRouteWithChildren = ProfileRoute._addFileChildren(ProfileRouteChildren)




const SettingsAuditLogsRouteChildren = {
  SettingsAuditLogsLogIdRoute: SettingsAuditLogsLogIdRoute
}

const SettingsAuditLogsRouteWithChildren = SettingsAuditLogsRoute._addFileChildren(SettingsAuditLogsRouteChildren)



const SettingsRouteChildren = {
  SettingsAdvancedRoute: SettingsAdvancedRoute,SettingsAnalyticsRoute: SettingsAnalyticsRoute,SettingsAuditLogsRoute: SettingsAuditLogsRouteWithChildren,SettingsCacheRoute: SettingsCacheRoute,SettingsDispatcherRoute: SettingsDispatcherRoute,SettingsLocationsRoute: SettingsLocationsRoute,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPoliciesRoute: SettingsPoliciesRoute,SettingsQuotasRoute: SettingsQuotasRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CallbackRoute: CallbackRoute,ProfileRoute: ProfileRouteWithChildren,SearchRoute: SearchRoute,SettingsRoute: SettingsRouteWithChildren,SnowHuntRoute: SnowHuntRoute,SearchStatusRoute: SearchStatusRoute,SnowHuntStatusRoute: SnowHuntStatusRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)